export default {
  // "apiURL": "http://dev.api.zglxgw.com",    // 测试接口
  "apiURL": "http://api.zglxgw.com",    // 接口地址
  "loginURL": "http://api.zglxgw.com/oauth/login",     // 登录地址
  "shareURL": "http://www.zglxgw.com",     // 分享链接
}